import {enc} from 'crypto-js';
import _ from 'lodash';
import moment from 'moment';

/**
 * Key used to store current token in local storage
 * @type {string}
 */
const MBAAS_TOKEN_KEY = 'mbaasToken';
/**
 * Key used to store token expiration as timestamp
 * @type {string}
 */
const MBAAS_TOKEN_EXPIRE = 'mbaasTokenExpire';

export default class SeldaAPIService {
  constructor(CryptService, $http, $httpParamSerializerJQLike, localStorageService, $q, Rollbar) {
    'ngInject';
    Object.assign(this, {$http, CryptService, $httpParamSerializerJQLike, localStorageService, $q, Rollbar});
    // static authentication parameters
    this.authParams = {
      "customer_KEY": 'FDM_FDM', // chiave univoca del cliente [obbligatorio]
      "app_KEY": 'FDM_FMConnect', // chiave univoca dell'app [obbligatorio]
      "app_VER": '1.1.0', // versione dell'app [obbligatorio]
      "os_KEY": 'ios', // chiave del sistema operativo [obbligatorio]
    };
    this.basicAuth = enc.Base64.stringify(enc.Utf8.parse('key_FMC_001:KeY@105#fmC'));
  }

  /**
   * Return a promise resolved with a token used to authenticate requests.
   * If a previous token has been requested and is still valid it will return that token.
   * Otherwise if no token present or if expired a new one is requested.
   */
  requestToken() {
    let message = JSON.stringify(this.authParams);
    let encryptedPayload = {
      mbaas_token_request: this.CryptService.encrypt(message),
      MD5: this.CryptService.sign(message),
    };
    // if a token is present use that token
    let currentToken = this._retrieveToken();
    if (currentToken) return this.$q.when(currentToken);
    // else fetch a new one and store it in local storage
    this._tokenRequest = this._tokenRequest || this._makeRequest('https://mbaas.selda.it/APIV1/requestToken', encryptedPayload)
      .then((a) => {
        try {
          let response = this.CryptService.decryptAndVerify(a.data, 'mbaas_token_response');
          this._saveToken(response);
          return response.token;
        } catch (e) {
          let payload = JSON.parse(this.CryptService.decrypt(a.data.mbaas_token_response));
          this.Rollbar.error('Verification mismatch when requesting token:', e, {error: payload});
          return this.$q.reject(payload);
        }
      });
    // return the memoized request, i.e. do the request once per class
    return this._tokenRequest;
  }

  requestService(service, params = {}) {
    let payload = _.extend({}, params, {richiesta: service});
    // userID and UID are mandatory (??) for service request, can be anything???
    payload = _.extend({}, this.authParams, {payload: payload, userID: '1', UID: '11', ws_KEY: 'FDM_WS_FMC_01'});
    // get a valid token and then make the request
    return this.requestToken().then((token) => {
      payload.token = token;
      let message = JSON.stringify(payload);
      let encryptedPayload = {
        mbaas_service_request: this.CryptService.encrypt(message),
        MD5: this.CryptService.sign(message),
      };
      console.debug(`Requesting service ${service} to SeldaAPI with params`, params);
      return this._makeRequest('https://mbaas.selda.it/APIV1/requestService', encryptedPayload)
        .then((a) => {
          try {
            let response = this.CryptService.decryptAndVerify(a.data, 'mbaas_service_response');
            return response.payload;
          } catch (e) {
            let payload = JSON.parse(this.CryptService.decrypt(a.data.mbaas_service_response));
            this.Rollbar.error(`Verification mismatch when requesting service '${service}'`, e, {params: params});
            return this.$q.reject(payload);
          }
        });
    });
  }

  _makeRequest(url, params) {
    // combine all headers to make a request to MBAAS
    let requestHeaders = _.extend({}, this.authParams, {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Basic ${this.basicAuth}`
    });

    // add CORS proxy
    url = 'https://cors-anywhere.herokuapp.com/' + url;
    // use runscope to trace request
    // url = url.replace('https://mbaas.selda.it', 'https://mbaas-selda-it-vsngaieqhcno.runscope.net');

    return this.$http({
      url: url,
      method: 'POST',
      data: this.$httpParamSerializerJQLike({parametro: JSON.stringify(params)}),
      headers: requestHeaders
    })
  }

  /**
   * Save received token and its validity in local storage
   * @param response
   * @private
   */
  _saveToken(response) {
    console.debug('Saving auth token', response.token, 'into local storage');
    this.localStorageService.set(MBAAS_TOKEN_KEY, response.token);
    let tokenExpiration = moment().add(parseInt(response.tokenExpire) - 2, 'minutes');
    console.debug('Saving expiration time', tokenExpiration.format(), 'into local storage');
    this.localStorageService.set(MBAAS_TOKEN_EXPIRE, tokenExpiration.valueOf());
  }

  /**
   * Retrieve received token from local storage or clear it if not valid anymore
   * @private
   */
  _retrieveToken() {
    let expiration = this.localStorageService.get(MBAAS_TOKEN_EXPIRE);
    console.debug('Token expiration timestamp is', expiration);
    if (expiration && moment(expiration).isAfter(moment())) {
      console.debug('Return still valid token:', this.localStorageService.get(MBAAS_TOKEN_KEY));
      return this.localStorageService.get(MBAAS_TOKEN_KEY);
    } else {
      console.info('Clearing expired token', this.localStorageService.get(MBAAS_TOKEN_KEY));
      this.localStorageService.remove(MBAAS_TOKEN_KEY);
      this.localStorageService.remove(MBAAS_TOKEN_EXPIRE);
      return null;
    }
  }
}


// WEBPACK FOOTER //
// ./client/app/services/selda_api_service.js